import React, { useState } from "react";
import './Admin.css';
import RTEditor from '../../utils/RTEditor';
import { savePrivacy } from "../../services/ConferenceInformation";
import { Alert } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";

export default function Privacy({ conferenceInfo, onConferenceInfoUpdate }: { conferenceInfo: any, onConferenceInfoUpdate: () => void }) {
  //Alert
  const [isShowAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const handleSave = async (editorContent: string) => {
    try {
      if (conferenceInfo?.Privacy !== editorContent) {
        await savePrivacy(editorContent);
        onConferenceInfoUpdate();
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 5000);
      }
    } catch (error) {
      setErrorMessage(true);
      setTimeout(() => {
        setErrorMessage(false);
      }, 5000);
    }
  };
  return (
    <div className="Margin">
      {isShowAlert && (
        <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
          Privacy successfully submitted.
        </Alert>
      )}
      {errorMessage && (
        <Alert icon={<ErrorIcon fontSize="inherit" />} severity="error">
          Error saving Privacy.
        </Alert>
      )}
      <div className="EditorContainer">
        <RTEditor editorName={"Privacy Statement"}
          content={conferenceInfo?.Privacy}
          saveContent={handleSave} />
      </div>
    </div>
  );
}
